<div class="page-body">
  <div *ngIf="!loading && error">
    <div class="error-wrapper">
      <div class="contents-container">
        <p class="heading">Något gick fel</p>
        <p class="info-text">
          Oj då, ser ut som att detta belopp inte kunde delas upp. Vänligen välj
          en annan betalmetod.
        </p>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="contents-wrapper">
      <div class="contents-container">
        <ng-container *ngFor="let item of presentedInstallmentPlans; let i = index">
          <!-- Ränterabatt (Discounted Interest Rate) -->
          <app-installments-item
            *ngIf="isDiscountedInterestRate(item)"
            [title]="getTitleStringDiscountedInterestRate(item.discountedMonthlyCost, item.numberOfMonths)"
            [selected]="presentedInstallmentPlans[i] === selectedInstallmentPlan"
            [bulletPoints]="getBulletPoints(item)"
            includeTermsLink="true"
            [link]="getLink(item)"
            [isFirstItem]="isFirstItem(i)"
            [isLastItem]="isLastItem(i)"
            [color]="'#00ac84'"
            (click)="select(i)"
            [radioButtonColor]="primaryColor"
            [isDiscountedInterestRate]="true"
            [yourInterestRate]="yourInterestRate(item)"
          ></app-installments-item>

          <!-- Standard 0% Interest (WITH badge) -->
          <app-installments-item
            *ngIf="!isDiscountedInterestRate(item) && item.nominalInterest < 0.001"
            [title]="getTitleString(item.monthlyCost, item.numberOfMonths)"
            [selected]="presentedInstallmentPlans[i] === selectedInstallmentPlan"
            badgeText="0% ränta"
            [bulletPoints]="getBulletPoints(item)"
            includeTermsLink="true"
            [link]="getLink(item)"
            [isFirstItem]="isFirstItem(i)"
            [isLastItem]="isLastItem(i)"
            [color]="'#00ac84'"
            (click)="select(i)"
            [radioButtonColor]="primaryColor"
            [isDiscountedInterestRate]="false"
          ></app-installments-item>

          <!-- Standard with Interest (NO badge) -->
          <app-installments-item
            *ngIf="!isDiscountedInterestRate(item) && 
            (item.nominalInterest >= 0.001 || item.nominalInterest * 100 === 0.1)"
            [title]="getTitleString(item.monthlyCost, item.numberOfMonths)"
            [selected]="presentedInstallmentPlans[i] === selectedInstallmentPlan"
            [bulletPoints]="getBulletPoints(item)"
            includeTermsLink="true"
            [link]="getLink(item)"
            [isFirstItem]="isFirstItem(i)"
            [isLastItem]="isLastItem(i)"
            [color]="'#00ac84'"
            (click)="select(i)"
            [radioButtonColor]="primaryColor"
            [isDiscountedInterestRate]="false"
          ></app-installments-item>
  
        </ng-container>

        <button
          *ngIf="availableInstallmentPlans.length > 3"
          class="installments-button"
          (click)="toggleExpandedView()"
        >
          {{ allInstallmentPlansIsShown() ? 'Visa färre' : 'Visa fler' }}
          <img
            class="installments-img"
            [src]="
              allInstallmentPlansIsShown()
                ? 'assets/icon/Arrow-Up.svg'
                : 'assets/icon/Arrow-Down.svg'
            "
          />
        </button>

        <div class="footer-wrapper">
          <div class="footer-container">
            <app-payment-request-info
              buttonText="Slutför köp"
              [isButtonDisabled]="navigating"
              [isButtonLoading]="loading"
              [lineItems]="paymentRequest.lineItems"
              [market]="paymentRequest.market"
              [value]="paymentRequest.value"
              [buttonLogo]="'/assets/icon/BankID-Vector-Logo-White.svg'"
              (onDetailsClick)="activateModal('Ditt köp')"
              (onContinueClick)="initSign()"
            ></app-payment-request-info>

            <p class="calculations">
              {{ currentLoanTermsStr }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="modalActive"
  [title]="'Visa detaljer'"
  (onClose)="deactivateModal()"
  [buttonText]="'Stäng'"
>
<app-selector
  #selector
  *ngIf="!!selectorItems"
  [selectorItems]="selectorItems"
  [selectedItem]="currentSelectedItem"
  [onOpenTerms]="openChoiceTerms.bind(this)"
  [isDiscountedInterestRate]="isDiscountedInterestRate(selectedInstallmentPlan)"
></app-selector>
</zaver-checkout-modal>
